import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import Cookie from "js-cookie";

// components
import Layout from "layout/index";
import { Box, Container, Typography, Stack, Button } from "@mui/material";
import { BottomButtons } from "components/unitComponent";
import { SvgIconStyle } from "components";

// translations
import { useTranslation } from "react-i18next";
import HomeIcon from "assets/icons/home-active.svg";
import ReceiptIcon from "assets/icons/receipt.svg";
import { minutesInHour } from "date-fns";

// ----------------------------------------------------------------------

export default function Complete() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const { orderData } = location?.state;
  const KIOSK_ID = Cookie.get("Kiosk_ID");
  const Festival_ID = Cookie.get("Festival_ID");

  const [printed, setPrinted] = useState(false);
  const [counter, setCounter] = useState(10); // 영수증 카운트

  function setReceipt() {
    if (typeof ChromeAPI == "undefined") return;
	
    ChromeAPI.toPrint({
      corpName: "주식회사 퀸즈스마일", // 회사이름
      corpNo: "766-87-00891", // 사업자번호
      addr: "대전광역시 유성구 773, 2층 201-가호 필로스페이스 비즈니스센터(에이치실 7호)", // 주소
      tel: "070-5165-3074", // 전화번호
      ...orderData,
      cardNo: orderData.cardNo || "-",
      cardName: orderData.cardName || "-",
      appNo: orderData.appNo || "-",
      price: Number(orderData.price).toLocaleString(),
    });
    setTimeout(() => {
      window.location.href = `/?code=${KIOSK_ID}`;
    }, 1000);
  }

  const startTimer = () => {
    setTimeout(() => {
      if (counter > 0) {
        setCounter((prev) => prev - 1);
      }
      if (counter <= 0) {
        window.location.href = `/?code=${KIOSK_ID}`;
      }
    }, 1000);
  };
  useEffect(() => {
    startTimer();
  }, [counter]);

  useEffect(() => {}, []);
  return (
    <Layout
      sx={{
        px: "0 !important",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        "&:-webkit-scrollbar": { display: "none" },
      }}
    >
      <Stack
        sx={{
          textAlign: "center",
          py: 30,
          height: "100%",
          gap: 4,
        }}
      >
        <Typography variant="h1" fontSize={40} color="primary.main">
          {/* 결제가 완료되었습니다 */}
          {t("complete-pay")}
        </Typography>
        <Typography variant="h4" whiteSpace={"pre-line"}>
          {t("complete-order-tablet")}
        </Typography>

        <Typography variant="h4">
          <span style={{ color: "#ff006e" }}>{`${counter}`}</span>
          {t("complete-timer")}
        </Typography>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 2,
            px: 14,
            mt: 12,
          }}
        >
          {Festival_ID === "243" ? (
            <Button
              variant="contained"
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 1,
                width: "50%",
                height: 160,
                "&:active": { backgroundColor: "primary.main" },
              }}
              onClick={() => setReceipt()}
            >
              <SvgIconStyle
                src={ReceiptIcon}
                sx={{ minWidth: 60, minHeight: 50 }}
              />
              <Typography variant="subtitle2" fontSize={30}>
                {t("receipt")}
              </Typography>
            </Button>
          ) : null}
          <Button
            variant="contained"
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 1,
              width: "50%",
              height: 160,
              //   bgcolor: "primary.main",
              bgcolor: Festival_ID === "243" ? "grey.100" : "primary.main",
              "&:active": {
                backgroundColor:
                  Festival_ID === "243" ? "grey.100" : "primary.main",
              },
            }}
            onClick={() => (window.location.href = `/?code=${KIOSK_ID}`)}
          >
            <SvgIconStyle src={HomeIcon} sx={{ minWidth: 50, minHeight: 50 }} />
            <Typography variant="subtitle2" fontSize={30}>
              {t("back-home")}
            </Typography>
          </Button>
        </Box>
      </Stack>
      {/* bottom =============================================== */}
      {/* <Box>
				<BottomButtons
					left={{
						label: t("back-home"),
						onClick: () => navigate("/"),
						icon: HomeIcon,
					}}
					// right={{
					//   label: t("receipt"),
					//   onClick: () => setReceipt(),
					// }}
				/>
			</Box> */}
    </Layout>
  );
}
